import { h } from "preact";
import styles from "./promoBannerPriceRow.module.css";

function PromoBannerPriceRow({ isSpecialPriceLayout, price, specialPrice }) {
    if (!isSpecialPriceLayout) return null;

    return (
        <div className={styles.specialPriceRow}>
            <span className={styles.priceOld}>R$ {price.toFixed(2)}</span>
            <span className={styles.priceNew}>R$ {specialPrice.toFixed(2)}</span>
        </div>
    );
}

export default PromoBannerPriceRow;
